import { forwardRef } from "react";

import { Box, Button, CircularProgress, type ButtonProps } from "@mui/material";
import { useTranslation } from "react-i18next";

export interface WaterlyButtonProps extends ButtonProps {
  translationKey: string;
  isLoading?: boolean;
}

/* eslint-disable react/prop-types -- TypeScript props provide the component contract here */
export const WaterlyButton = forwardRef<HTMLButtonElement, WaterlyButtonProps>(function WaterlyButton(
  { translationKey = "common:add", isLoading = false, disabled, children, color = "primary", ...rest },
  ref,
) {
  const { t } = useTranslation();
  const label = children ?? t(translationKey);

  return (
    <Button ref={ref} color={color} disabled={disabled ?? isLoading} {...rest}>
      {isLoading ? (
        <Box component="span" display="inline-flex" alignItems="center" gap={1}>
          <CircularProgress size={16} color="inherit" />
          {label}
        </Box>
      ) : (
        label
      )}
    </Button>
  );
});
/* eslint-enable react/prop-types */
